import Api from "@/api/index";
// import store from "@/store";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const roles = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    queryParam: {},
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
  },
  actions: {
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("roles/page", payload).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doPaginate("roles").then(({ data }) => {
        commit("SET_ALL", data);
        commit("SET_LOADING", false);
      });
    },
    // async paginate({ commit }, payload) {
    //   commit("SET_LOADING", payload.loading);
    //   commit("SET_QUERY_PARAM", payload.datas);
    //   return await Api.doGet(
    //     "roles/page", payload.datas
    //   ).then(({ data }) => {
    //     commit("SET_DATAS", data);
    //     commit("SET_DATA", data.data.data);
    //     commit("SET_LOADING", false);
    //   });
    // },
    setIsAactiveFalse({ commit, state }) {
      const menuNew = state.sidebar;
      menuNew.forEach((element, i) => {
        if (element.slug === "dropdown") {
          menuNew[i].isActive = false;
        }
      });
      commit("SET_SIDEBAR", menuNew);
    },
  },
};

export default roles;
